// ═══════════════════════════════════════════════════════════════════
//  modules/wiki/WikiDocumenterBouton.js
//  WikiDocumenterBouton
// ═══════════════════════════════════════════════════════════════════

import { THEME } from "../../socle/theme";
import { ouvrirWiki } from "./navigation";

// ═══════════════ Bouton « Documenter dans le wiki » (lot 3) ═══════════════
//  À poser dans le registre de sujets de l'analyse IA du chat :
//     <WikiDocumenterBouton sujet={sujet} />
//  Une question posée 14 fois n'est pas une tâche : c'est une page qui manque.
export function WikiDocumenterBouton({ sujet }) {
  if (!sujet) return null;

  const documenter = () => {
    const extraits = (sujet.extraits || []).slice(0, 6);
    const canaux = (sujet.canaux || []).length > 1 ? " (en jeu et sur Discord)" : "";
    const contenu = [
      "## La question posée par les joueurs",
      "",
      `Revenue **${sujet.occurrences || "plusieurs"} fois**${canaux}, relevée par l'analyse du chat.`,
      sujet.description ? `\n${sujet.description}` : "",
      "",
      "## Ce qu'ils demandent exactement",
      "",
      ...(extraits.length ? extraits.map((e) => `- « ${e} »`) : ["- à compléter"]),
      "",
      "## La réponse",
      "",
      "à compléter — puis « ✍️ Rédiger » si tu veux que l'assistant mette ça en forme.",
      "",
      "## À vérifier",
      "",
      "- [ ] la réponse est-elle toujours exacte après la dernière mise à jour ?",
    ].join("\n");

    ouvrirWiki({
      type: "creer",
      titre: `FAQ — ${sujet.titre}`,
      contenu,
      categorie: "general",
      tags: "faq, chat",
    });
  };

  return (
    <button onClick={documenter} title="Créer une page de wiki pré-remplie à partir de ce sujet"
      style={{ background: THEME.purpleDim, border: `1px solid ${THEME.purple}`, color: THEME.purple, borderRadius: 6, padding: "7px 14px", cursor: "pointer", fontSize: 12, fontWeight: 700, fontFamily: "inherit" }}>
      📚 Documenter dans le wiki
    </button>
  );
}
